import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { ContactDetails } from '../components/ContactDetails';
import { CTABand } from '../components/CTABand';
import { site, images, promises, credentials, bbbFacts, scopeLine } from '../data/site';
import { counties } from '../data/serviceAreas';
export function About() {
  return <>
      <PageHero eyebrow="About" title="A full service licensed and insured builder" description={scopeLine} crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'About'
    }]} image={images.about} data-id="element-257" data-mp="377x93q20vk2k" />

      <section className="mx-auto grid max-w-7xl gap-10 px-6 py-14 lg:grid-cols-[1.4fr_1fr] md:py-20" data-id="element-258" data-mp="2x7mymd7dgqr3">
        <div data-id="element-259" data-mp="1gtn096o6d95y">
          <SectionHeading eyebrow="Who we are" title="Repair, update, renovate" data-id="element-260" data-mp="1gx2j8kkyz2cn" />
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-ink-600" data-id="element-261" data-mp="1uhs6j7omb1dz">
            <p data-id="element-262" data-mp="1ujw8vl6vbsc5">
              TOTAL Home Improvement is a full service, state licensed and
              insured builder based in Wixom, Michigan. We handle work inside
              and outside the home, from the roof to the basement, in all four
              seasons of the year.
            </p>
            <p data-id="element-263" data-mp="1ylhrzo9zx2us">
              That range is the point. A single project can move through
              carpentry, plumbing, electrical, drywall, flooring, painting and
              exterior work without you having to line up and manage separate
              contractors for each trade. We also take on smaller repairs and
              honey-do lists, and we work on commercial property as well as
              homes.
            </p>
            <p data-id="element-264" data-mp="2w6m6utkpqyst">
              We also pour cement driveways and install decorative and stamped
              cement patios and driveways as part of our exterior work.
            </p>
          </div>

          <img src={images.building} alt="Home construction and building work" className="mt-8 h-72 w-full rounded-sm border border-steel-200 object-cover" data-id="element-265" data-mp="1ov68terv6h1q" />

          <h2 className="mt-12 border-b-2 border-safety pb-2 font-display text-2xl font-bold uppercase tracking-tight text-ink" data-id="element-266" data-mp="1xv2sf1zecppx">
            Credentials
          </h2>
          <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-267" data-mp="22nvufi3hdjyb">
            {credentials.map(c => <li key={c} className="flex items-start gap-2.5 rounded-sm border border-steel-200 bg-white px-4 py-3 text-sm font-semibold text-ink" data-id="element-268" data-mp="27ngz895c0miy">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-safety" aria-hidden="true" data-id="element-269" data-mp="2gjzpfdm6hwbu" />
                {c}
              </li>)}
          </ul>
          <div className="mt-4 flex items-center gap-5" data-id="element-270" data-mp="m9cgv2m0ps2u">
            <img src={images.bbb} alt="Better Business Bureau" className="h-12 w-auto" data-id="element-271" data-mp="r6midgmolu71" />
            <img src={images.epa} alt="Lead Safe EPA Certified" className="h-12 w-auto" data-id="element-272" data-mp="jnd7tk2fvpge" />
          </div>

          <h2 className="mt-12 border-b-2 border-safety pb-2 font-display text-2xl font-bold uppercase tracking-tight text-ink" data-id="element-273" data-mp="ewwr9r3bnnpt">
            Better Business Bureau record
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-steel-500" data-id="element-274" data-mp="4yh0xqc4cihd">
            The following details are listed on the company&apos;s Better
            Business Bureau profile.
          </p>
          <dl className="mt-4 grid gap-px overflow-hidden rounded-sm border border-steel-200 bg-steel-200 sm:grid-cols-2" data-id="element-275" data-mp="12jv2oacl45gv">
            {bbbFacts.map(f => <div key={f.label} className="bg-white px-4 py-3" data-id="element-276" data-mp="smgokhe4vsrq">
                <dt className="text-xs font-bold uppercase tracking-[0.16em] text-steel-400" data-id="element-277" data-mp="omzlfum6j7pq">
                  {f.label}
                </dt>
                <dd className="mt-0.5 text-base font-semibold text-ink" data-id="element-278" data-mp="3dflj9zgc4rmw">
                  {f.value}
                </dd>
              </div>)}
          </dl>
          <a href={site.social.bbb} target="_blank" rel="noreferrer" className="mt-3 inline-block text-sm font-bold uppercase tracking-wide text-safety hover:underline" data-id="element-279" data-mp="112xv4ztgz5vo">
            View the BBB profile →
          </a>
        </div>

        <aside className="space-y-6 lg:sticky lg:top-32 lg:self-start" data-id="element-280" data-mp="w44itapx5kx3">
          <ContactDetails data-id="element-281" data-mp="1jugv0xs763th" />
          <div className="rounded-sm border border-steel-200 bg-white p-6 shadow-card" data-id="element-282" data-mp="1ju7334nldml5">
            <h2 className="font-display text-lg font-semibold uppercase tracking-tight text-ink" data-id="element-283" data-mp="1ou37v6445i1r">
              Service area
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-steel-500" data-id="element-284" data-mp="1atir0fhrdwaw">
              {counties.join(', ')} Counties, Michigan.
            </p>
            <Link to="/service-area" className="mt-3 inline-block text-sm font-bold uppercase tracking-wide text-safety hover:underline" data-id="element-285" data-mp="3vk9g4urnm0k9">
              See all cities →
            </Link>
          </div>
        </aside>
      </section>

      <section className="bg-ink" data-id="element-286" data-mp="3s3wuf6njoo60">
        <div className="mx-auto max-w-7xl px-6 py-14 md:py-20" data-id="element-287" data-mp="3n3iopv9f1qb5">
          <SectionHeading light eyebrow="Our promise" title="How we work on your property" data-id="element-288" data-mp="3n5d5qyhkgy9y" />
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-289" data-mp="vj1sm1qhm7u">
            {promises.map(p => <div key={p.title} className="border-t-4 border-safety bg-ink-800 p-6" data-id="element-290" data-mp="39cnhsoih9ja7">
                <h3 className="font-display text-xl font-semibold uppercase tracking-tight text-white" data-id="element-291" data-mp="34dap3n4xdhzp">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-steel-300" data-id="element-292" data-mp="3j38geby5int4">
                  {p.body}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-14" data-id="element-293" data-mp="2qirrrq3u94o9">
        <SectionHeading eyebrow="Elsewhere" title="Find us online" description="Our profiles on other platforms, for reference." data-id="element-294" data-mp="2ll8easeysvxd" />
        <div className="mt-6 grid gap-4 sm:grid-cols-3" data-id="element-295" data-mp="3fb8tkpzdyhmt">
          {[{
          label: 'Facebook',
          href: site.social.facebook
        }, {
          label: 'Houzz',
          href: site.social.houzz
        }, {
          label: 'Better Business Bureau',
          href: site.social.bbb
        }].map(l => <a key={l.label} href={l.href} target="_blank" rel="noreferrer" className="rounded-sm border border-steel-200 bg-white px-5 py-4 font-display text-lg font-semibold uppercase tracking-tight text-ink transition hover:border-safety hover:text-safety" data-id="element-296" data-mp="2sbkpqkaqtwc6">
              {l.label}
            </a>)}
        </div>
      </section>

      <CTABand data-id="element-297" data-mp="gmjq35b66gxy" />
    </>;
}